import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M8 3v3a2 2 0 0 1-2 2H3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M21 8h-3a2 2 0 0 1-2-2V3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M3 16h3a2 2 0 0 1 2 2v3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16 21v-3a2 2 0 0 1 2-2h3", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Minimize";
const Minimize = memo(themed(Icon));
export {
  Minimize
};
//# sourceMappingURL=minimize.js.map
